import * as React from 'react'

import {useVisibility} from '../../../../../../common/Visible/Visible.hooks'
import type {AgentsTreeAgentNode} from '../../../../AgentsSidebar/AgentsSidebar.types'
import AgentFetcher from '../../../AgentFetcher/AgentFetcher'
import AgentListView from '../../../AgentListView/AgentListView'
import AgentPlaceholderListView from '../../../AgentListView/AgentPlaceholderListView'

function VisibleAgent({
  className,
  ...agentNode
}: AgentsTreeAgentNode & {
  className: string
}) {
  const ref = React.useRef(null)
  const isVisible = useVisibility(ref)
  return (
    <div ref={ref} className={className}>
      {isVisible ? ( // TODO: fetch agent's data only is the user has `View agent details` permission
        <AgentFetcher agentId={agentNode.id}>
          {({agent}) => {
            if (agent != null) {
              return <AgentListView agent={agent} removable={agentNode.removable} />
            }

            return <AgentPlaceholderListView {...agentNode} />
          }}
        </AgentFetcher>
      ) : (
        <AgentPlaceholderListView {...agentNode} />
      )}
    </div>
  )
}

export default VisibleAgent
